export default __webpack_public_path__ + "static/bg-03-e652c1cafb0cba3eb1399468b0fc2258.png";